export default function inDateColumn() {
    return {
        restrict: 'E',
        scope: {
            value: '&',
            field: '<'
        },
        link: function(scope) {
            var field = scope.field;
            scope.format = field.format();
            if (!scope.format) {
                scope.format = field.type() === 'date' ? 'dd.MM.yyyy' : 'dd.MM.yyyy HH:mm:ss';
            }
        },
        template: '<span>{{ value() | date:format }}</span>'
    };
}

inDateColumn.$inject = [];



// WEBPACK FOOTER //
// ./app/components/common/crud/column/inDateColumn.js